module.exports = __webpack_public_path__ + "img/disable-icon.c7bd5116.svg";